import React from "react";
import { useParams } from "react-router-dom";
import Img from "../components/Img";
import { IMG_SERVER_URL } from "../utils/constant";

const ImagePreview = () => {
  const { id } = useParams();
  return (
    <div className="flex justify-center items-center h-screen w-full">
      <Img
        className="max-h-screen"
        src={`${IMG_SERVER_URL}/brick-img/${id}.jpg`}
      />
    </div>
  );
};

export default ImagePreview;
